const appInfo = {
    title: 'Quadrantis'
};
export default appInfo;

